import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { BrandmodelModel } from '../../../model/index';
import { BrandmodelService, CommonService } from '../../../services/index';

@Component({
    selector: 'add-edit-brand-model-window',
    templateUrl: './addEditBrandmodel.component.html'
})
export class AddEditBrandmodelComponent implements OnInit {

    public list: any[] = [];

    @Output() brandUpdateEvent = new EventEmitter();
    title: string;
    mode: string;
    @Input() brandmodeldata: BrandmodelModel[] = [];

    //brandCtrl: FormControl;
    //filteredItems: Observable<any[]>;
    //@ViewChild('brandAutoComp') brandAutoComp;

    //itemList: any[] = [];
    brandList$ = [];
    // trigger-variable for Ladda
    isLoading: boolean = false;


    constructor(public store: Store<fromRootStore.State>, private brandmodelService: BrandmodelService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService, private commonService: CommonService) {
        //FOR AUTO COMPLETE VALIDATION
        // function hasValidBrand(input: FormControl) {
        //     let brandID = input.value, retVal = null;
        //     if(brandID==""){
        //         retVal = { inValidBrand: true };
        //     }
        //     if(brandID && typeof brandID==='string'){
        //         retVal = { inValidBrand: true };
        //     }
        //     return retVal;
        // }
        //
        // this.brandCtrl = new FormControl('', [
        //   Validators.required,
        //   hasValidBrand.bind(this)
        // ]);
        // //this.brandCtrl = new FormControl();
        // this.filteredItems = this.brandCtrl.valueChanges
        //     .startWith(null)
        //     .map(name => name ? this.filterItems(name) : this.brandList$.slice());
    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#brand_model_name').focus();
        }, 100);
        //this.loadBrandItemList();
        //this.brandAutoComp.optionSelected.subscribe(this.onSelectedBrand.bind(this));
        // this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
        //     if (_.isEmpty(res)) {
        //         //this.store.dispatch(new commonActions.LoadAllBrand());
        //         //this.brandList$ = res;
        //         return;
        //     }
        //     this.brandList$ = res;
        // });
    }

    //loadBrandItemList() {
    // let that = this;
    // this.commonService
    //     .getBrandList()
    //     .then(function(res: any) {
    //         that.itemList = res;
    //         that.brandCtrl.setValue(that.brandmodeldata['brand_id']);
    // 		/*if (that.mode == "Edit") {
    // 			that.brandCtrl.disable();
    // 			$('#name').focus();
    // 		}*/
    //     });
    //}

    // filterItems(name: string) {
    //     name = _.escapeRegExp(name);
    //     return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.brand_code) || new RegExp(name, 'gi').test(item.name)));
    // }
    //
    // displayFn(brandID: number) {
    //     if (brandID && this.brandList$.length > 0) {
    //         let fitem = _.find(this.brandList$, { 'brand_id': brandID });
    //         return fitem['name'];
    //     }
    //     return '';
    // }

	/*onSelectedBrand(mdCompEvent: any) {
		let item_id = mdCompEvent.option.value,
			fitem = _.find(this.itemList, { 'brand_id': item_id });
		//this.skudata['jms_item_id'] = fitem.item_id;
		this.brandmodeldata['brandmodel_id'] = fitem.brand_code;
		this.brandmodeldata['brandmodel_name'] = fitem.name;
	}*/


    // onEnterKeyPressed(nextEl: string): void {
    //     $('#' + nextEl).focus();
    // }

    onSaveBrandmodel(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        // if (_.isEmpty(this.brandmodeldata['brand_id'])) {
        //     toast['body'] = 'Please Select Brand ';
        //     this.toasterService.pop(toast);
        //     return;
        // }
        let that = this;
        this.isLoading = true;
        this.brandmodelService
            .addUpdateBrandmodel(this.brandmodeldata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.brandUpdateEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/brandModel/addEditBrandmodel.component.ts